var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"slide-action-btn",class:_vm.isCollab ? 'btn-annotate' : 'btn-notes',on:{"click":_vm.openDraw}},[_c('i',{class:_vm.isCollab ? 'el-icon-edit' : 'el-icon-document'}),_c('span',[_vm._v(_vm._s(_vm.isCollab ? 'Annotate' : 'Notes'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }